import { useState } from 'react';
import TopBar from '../components/TopBar';
import BottomNav from '../components/BottomNav';
import { useLang } from '../LangContext';
import { useT } from '../i18n';

const MENU_ITEMS = [
  { id: 1, nameZh: '黑糖珍珠鮮奶', nameEn: 'Brown Sugar Pearl', nameJa: '黒糖パールミルク', price: '$6.50', cat: 'milk' },
  { id: 2, nameZh: '絲絨芋泥鮮奶', nameEn: 'Velvet Taro Milk',  nameJa: 'ベルベットタロミルク', price: '$7.20', cat: 'milk' },
  { id: 3, nameZh: '茉莉綠茶',     nameEn: 'Jasmine Green',    nameJa: 'ジャスミングリーン',   price: '$5.50', cat: 'fruit' },
  { id: 4, nameZh: '雲朵抹茶',     nameEn: 'Matcha Cloud',     nameJa: '抹茶クラウド',         price: '$7.50', cat: 'matcha', wide: true },
  { id: 5, nameZh: '經典泰式',     nameEn: 'Classic Thai Pearl',nameJa: 'クラシックタイパール', price: '$6.80', cat: 'milk' },
];

const CATEGORIES = [
  { key: 'all',    labelKey: 'catMilkTea', icon: '🧋' },
  { key: 'milk',   labelKey: 'catMilkTea', icon: '🥛' },
  { key: 'fruit',  labelKey: 'catFruitTea', icon: '🍓' },
  { key: 'coffee', labelKey: 'catCoffee',  icon: '☕' },
  { key: 'matcha', labelKey: 'catMatcha',  icon: '🍵' },
];

// Pastel bg colors for drink cards
const CARD_COLORS = ['#fff3e8','#f0f4ff','#f0fff8','#fffbe8','#f8f0ff'];

function DrinkCard({ item, lang }) {
  const name = lang === 'zh' ? item.nameZh : lang === 'ja' ? item.nameJa : item.nameEn;
  const subtitle = lang === 'zh' ? item.nameEn : item.nameZh;

  return (
    <div style={{
      backgroundColor: '#ffffff',
      borderRadius: 24, padding: 12,
      display: 'flex', flexDirection: 'column',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* Image placeholder */}
      <div style={{
        aspectRatio: '1/1',
        borderRadius: 18,
        overflow: 'hidden',
        backgroundColor: CARD_COLORS[item.id % CARD_COLORS.length],
        marginBottom: 10,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 48,
      }}>
        {['🧋','🥛','🍵','🧉','🍵'][item.id % 5]}
      </div>
      <div style={{ padding: '0 2px' }}>
        <h3 style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 700, fontSize: 12, color: '#2d2d42', lineHeight: 1.3, marginBottom: 2,
        }}>{name}</h3>
        <p style={{ fontSize: 10, color: '#75748d', marginBottom: 8 }}>{subtitle}</p>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontWeight: 700, fontSize: 13, color: '#b02600',
          }}>{item.price}</span>
          <button style={{
            width: 32, height: 32, borderRadius: '50%',
            backgroundColor: '#FF5C36', border: 'none',
            color: '#ffffff', fontSize: 18, fontWeight: 700,
            cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 4px 12px rgba(255,92,54,0.25)',
            transition: 'transform 0.15s',
          }}>+</button>
        </div>
      </div>
    </div>
  );
}

export default function MenuScreen() {
  const { lang } = useLang();
  const t = useT(lang);
  const [activeCat, setActiveCat] = useState('all');
  const [searchVal, setSearchVal] = useState('');

  const filtered = MENU_ITEMS.filter(item => {
    const matchCat = activeCat === 'all' || item.cat === activeCat;
    const name = lang === 'zh' ? item.nameZh : lang === 'ja' ? item.nameJa : item.nameEn;
    const matchSearch = !searchVal || name.toLowerCase().includes(searchVal.toLowerCase()) || item.nameZh.includes(searchVal);
    return matchCat && matchSearch;
  });

  return (
    <div style={{
      backgroundColor: '#f8f5ff',
      minHeight: '100dvh',
      paddingTop: 56,
      paddingBottom: 100,
      fontFamily: "'Be Vietnam Pro', sans-serif",
    }}>
      <TopBar />

      <div style={{ padding: '16px 16px', maxWidth: 480, margin: '0 auto' }}>

        {/* ── Search ──────────────────────────────── */}
        <div style={{ position: 'relative', marginBottom: 20 }}>
          <div style={{
            position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)',
            pointerEvents: 'none',
          }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="#75748d">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
          </div>
          <input
            type="text"
            placeholder={t('searchPlaceholder')}
            value={searchVal}
            onChange={e => setSearchVal(e.target.value)}
            style={{
              width: '100%',
              backgroundColor: '#ffffff',
              border: 'none',
              borderRadius: 16,
              padding: '14px 16px 14px 42px',
              color: '#2d2d42',
              fontSize: 14,
              fontFamily: "'Be Vietnam Pro', sans-serif",
              boxShadow: '0 2px 8px rgba(45,45,66,0.04)',
              outline: 'none',
            }}
          />
        </div>

        {/* ── Featured promo banner ────────────────── */}
        <section style={{
          position: 'relative', overflow: 'hidden',
          borderRadius: 24, height: 176, marginBottom: 24,
          backgroundColor: '#ff7857',
          display: 'flex', alignItems: 'center', padding: '0 28px',
        }}>
          <div style={{ zIndex: 10, maxWidth: '55%' }}>
            <div style={{
              display: 'inline-block', marginBottom: 8,
              backgroundColor: '#f9cc61', color: '#443100',
              padding: '2px 10px', borderRadius: 9999,
              fontSize: 9, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em',
            }}>{t('weeklySpecial')}</div>
            <h2 style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 900, fontSize: 28, color: '#490a00',
              lineHeight: 1.1, fontStyle: 'italic', textTransform: 'uppercase',
              letterSpacing: '-0.02em', marginBottom: 4,
            }}>{t('mangoTitle')}</h2>
            <p style={{ fontSize: 12, color: '#5a0f00', fontWeight: 500, opacity: 0.9 }}>
              {t('mangoDesc')}
            </p>
          </div>
          {/* Decorative mango emoji */}
          <div style={{
            position: 'absolute', right: -8, top: 0, bottom: 0,
            width: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 80, transform: 'rotate(12deg) scale(1.2)',
            transformOrigin: 'bottom right',
          }}>🥭</div>
        </section>

        {/* ── Category tabs ────────────────────────── */}
        <div style={{
          display: 'flex', gap: 10, overflowX: 'auto', paddingBottom: 14, marginBottom: 14,
          scrollbarWidth: 'none', WebkitOverflowScrolling: 'touch',
        }}>
          {CATEGORIES.map(({ key, labelKey, icon }) => {
            const active = activeCat === key;
            return (
              <button
                key={key}
                onClick={() => setActiveCat(key)}
                style={{
                  flexShrink: 0,
                  backgroundColor: active ? '#FF5C36' : '#ffffff',
                  color: active ? '#ffffff' : '#5a5971',
                  border: 'none',
                  padding: '8px 16px',
                  borderRadius: 9999,
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontWeight: 700, fontSize: 13,
                  cursor: 'pointer',
                  display: 'flex', alignItems: 'center', gap: 6,
                  boxShadow: active ? '0 4px 12px rgba(255,92,54,0.25)' : '0 2px 8px rgba(45,45,66,0.04)',
                  transition: 'all 0.2s',
                  whiteSpace: 'nowrap',
                }}
              >
                <span>{icon}</span>
                {t(labelKey)}
              </button>
            );
          })}
        </div>

        {/* ── Menu grid ────────────────────────────── */}
        <div style={{
          display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14,
        }}>
          {filtered.map(item => (
            <DrinkCard key={item.id} item={item} lang={lang} />
          ))}
        </div>

        {filtered.length === 0 && (
          <div style={{ textAlign: 'center', padding: '48px 0', color: '#75748d' }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>🧋</div>
            <p style={{ fontSize: 14, fontWeight: 500 }}>No drinks found</p>
          </div>
        )}

      </div>

      {/* ── FAB: Points ─────────────────────────── */}
      <div style={{
        position: 'fixed', bottom: 88, right: 20,
        maxWidth: 390, zIndex: 40,
      }}>
        <button style={{
          backgroundColor: '#f9cc61', color: '#443100',
          border: 'none', borderRadius: 9999,
          padding: '10px 18px',
          display: 'flex', alignItems: 'center', gap: 8,
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 700, fontSize: 13,
          boxShadow: '0px 12px 32px rgba(45,45,66,0.12)',
          cursor: 'pointer', transition: 'transform 0.15s',
        }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          240 pts
        </button>
      </div>

      <BottomNav />
    </div>
  );
}
